// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  Auth, 
  setPersistence, 
  browserLocalPersistence
} from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase - Main app for landlord authentication
const app = initializeApp(firebaseConfig);

// Initialize Firebase - Separate app for tenant authentication
const tenantApp = initializeApp(firebaseConfig, 'tenant-auth');

// Main auth instance for landlord authentication
const auth: Auth = getAuth(app);

// Tenant auth instance - completely separate from main auth
const tenantAuth: Auth = getAuth(tenantApp);

// Set persistence to local storage for main auth
setPersistence(auth, browserLocalPersistence).catch((error) => {
  if (process.env.NODE_ENV === 'development') {
    console.error('Error setting Firebase main persistence:', error);
  }
});

// Set persistence to local storage for tenant auth
setPersistence(tenantAuth, browserLocalPersistence).catch((error) => {
  if (process.env.NODE_ENV === 'development') {
    console.error('Error setting Firebase tenant persistence:', error);
  }
});

export { auth, tenantAuth };
